import { Link } from "react-router-dom";
import { categoryMap } from "@/mocks/categories";

interface ArticleCardData {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  categorySlug: string;
  date: string;
  readTime: number;
  imageUrl: string;
}

const articleCards: ArticleCardData[] = [
  {
    id: "art-1",
    title: "JM网页版官网入口 - 最新官方直达通道使用指南",
    slug: "jm-official-entry-guide",
    excerpt: "本文详细介绍JM网页版官网入口的最新使用方式，包括如何找到官方入口、注册登录流程、以及使用过程中的注意事项，帮助您安全稳定地访问JM平台。",
    categorySlug: "tutorial",
    date: "2026-08-08",
    readTime: 8,
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20soft%20neutral%20colors%2C%20professional%20photography%20with%20shallow%20depth%20of%20field&width=800&height=400&seq=article-guide-01&orientation=landscape",
  },
  {
    id: "art-2",
    title: "JM网页版最新入口地址更新公告（2026年8月）",
    slug: "jm-latest-entry-update-august-2026",
    excerpt: "JM网页版官方发布最新入口地址更新公告，确保用户能够安全稳定地访问JM平台。本文汇总了本月所有入口变更信息及使用建议。",
    categorySlug: "news",
    date: "2026-08-05",
    readTime: 6,
    imageUrl: "https://readdy.ai/api/search-image?query=Digital%20network%20connection%20concept%20with%20glowing%20nodes%20and%20links%2C%20warm%20golden%20accents%2C%20minimalist%20tech%20style%2C%20soft%20gradient%20background%2C%20abstract%20geometric%20pattern&width=800&height=400&seq=article-news-01&orientation=landscape",
  },
  {
    id: "art-3",
    title: "JM网页版无法访问？这里有完整的解决方案",
    slug: "jm-web-access-troubleshooting",
    excerpt: "遇到JM网页版无法访问的问题？本文整理了常见的访问故障及对应的解决方案，帮助您快速恢复JM网页版的正常使用。",
    categorySlug: "faq",
    date: "2026-08-03",
    readTime: 5,
    imageUrl: "https://readdy.ai/api/search-image?query=Technical%20support%20and%20troubleshooting%20concept%2C%20clean%20workspace%20with%20laptop%20displaying%20code%2C%20warm%20lighting%2C%20modern%20minimalist%20aesthetic%2C%20professional%20environment&width=800&height=400&seq=article-faq-01&orientation=landscape",
  },
  {
    id: "art-4",
    title: "JM网页版安全使用完全手册：保护你的账号与隐私",
    slug: "jm-web-security-handbook",
    excerpt: "全面了解JM网页版的安全使用规范，学习如何保护账号安全、识别钓鱼网站、设置强密码等关键安全措施。",
    categorySlug: "security",
    date: "2026-08-01",
    readTime: 7,
    imageUrl: "https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20warm%20golden%20and%20teal%20accents%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20abstract%20technology%20background&width=800&height=400&seq=article-security-01&orientation=landscape",
  },
];

export default function HomeArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              最新文章
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              JM网页版使用指南与最新资讯
            </h2>
          </div>
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {articleCards.map((article) => {
            const cat = categoryMap[article.categorySlug];
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
              >
                <div className="h-40 w-full overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2.5">
                    {cat && (
                      <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">
                      {article.date}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                    <span className="text-xs text-foreground-500">
                      <i className="ri-time-line mr-1"></i>
                      {article.readTime}分钟阅读
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}